/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withRouter } from 'react-router';
import { Query } from 'react-apollo';
import {
    string, shape, arrayOf, number, object, func,
} from 'prop-types';
import mbpLogger from 'mbp-logger';
import { getProductDetailBySKU } from '../../../../../../pages/Account/services/graphQL';
import { GRAPHQL_ENV } from '../../../../../../gql';
import GraphqlFoodQuickView from './GraphqlFoodQuickView';
import GraphqlPortalLoader from '../../../../GraphqlCommonComponents/GraphqlPortalLoader';

const GraphqlFoodQuickViewContainer = ({
    product,
    selectedSku,
    location,
    productUrl,
    brand,
    renderSkuPrice,
}) => {
    const domain = brand ? brand?.domain : null;
    const SKU = selectedSku ? selectedSku.id : null;
    const FIND_PDP_BY_PART = getProductDetailBySKU(SKU, domain, GRAPHQL_ENV);
    return (
        <Query query={FIND_PDP_BY_PART}>
            {({ loading, data, error }) => {
                if (loading) {
                    return <GraphqlPortalLoader />;
                }
                if (error) {
                    mbpLogger.logError({
                        query: FIND_PDP_BY_PART,
                        component: 'GraphqlFoodQuickViewContainer.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        query: FIND_PDP_BY_PART,
                        component: 'GraphqlFoodQuickViewContainer.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                return (
                    <>
                        <GraphqlFoodQuickView
                            quickViewData={data?.findProductByPartNumber}
                            product={product}
                            selectedSku={selectedSku}
                            location={location}
                            productUrl={productUrl}
                            brand={brand}
                            renderSkuPrice={renderSkuPrice}
                        />
                    </>
                );
            }}
        </Query>
    );
};

GraphqlFoodQuickViewContainer.propTypes = {
    brand: object.isRequired,
    selectedSku: shape({
        id: string.isRequired,
        name: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
        __typename: string.isRequired,
    }).isRequired,
    product: shape({
        name: string.isRequired,
        partNumber: string.isRequired,
        shortDescription: string.isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }).isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
            productDeliveryType: string.isRequired,
        }).isRequired,
    }).isRequired,
    productUrl: string.isRequired,
    location: object.isRequired,
    renderSkuPrice: func.isRequired,
};

export default withRouter((GraphqlFoodQuickViewContainer));
